import { Action, Reducer } from 'redux';
import { ModalTypes, ModalState, ModalActionTypes } from './modalTypes';

const INITIAL_STATE: ModalState = {
  open: false,
  name: null
};

const modalReducer: Reducer<ModalState> = (
  state: ModalState = INITIAL_STATE,
  action: Action
) => {
  const actionTypes = action as ModalActionTypes;
  switch (actionTypes.type) {
    case ModalTypes.SET_MODAL_IS_OPENED:
      return {
        ...state,
        open: actionTypes.payload.open,
        name: actionTypes.payload.name
      };
    default:
      return state;
  }
};

export default modalReducer;
